const getWebsiteFlowsFetchRequestState = state => state.automationTab.websiteFlows.fetchRequestState;
export default getWebsiteFlowsFetchRequestState;